import React from "react";
import { TiDeviceDesktop, TiVendorAndroid } from "react-icons/ti";
import { TiVendorApple } from "react-icons/ti";
import { ImFire } from "react-icons/im";
import { Offer } from "interfaces/Offer";
import { transformCurrency } from "utils/functions/currencyModUtil";
import { getOfferSaleMultiplierLabel } from "utils/functions/offerSaleUtil";
import * as c from "./HeroOfferCardItem.module.css";

interface HeroOfferCardItemProps {
  onModalOpen: (offer: Offer) => void;
  offer: Offer;
  currencyName: string;
  index: number;
  isMostPopular: boolean;
  detectOs: boolean;
}

type Platform = "Android" | "iOS" | "Windows";

const platformIcons: Record<Platform, React.JSX.Element> = {
  Android: <TiVendorAndroid color="#A6D864" />,
  iOS: <TiVendorApple />,
  Windows: <TiDeviceDesktop size={14} color="#00a5ed" />,
};

function HeroOfferCardItem({
  onModalOpen,
  offer,
  currencyName,
  index,
  isMostPopular,
  detectOs,
}: HeroOfferCardItemProps) {
  const currency = transformCurrency(currencyName, offer.rewardIac);
  const originalCurrency =
    offer.promotion == null
      ? undefined
      : transformCurrency(currencyName, offer.promotion?.originalRewardIac!);
  const goals = offer.standardGoals?.concat(offer.purchaseGoals || []) || [];
  const isMultiGoal = goals.length > 1;

  const showHeroImage = () => {
    if (isMostPopular && detectOs) {
      return true;
    }
    if (isMostPopular && !detectOs && index < 1) {
      return true;
    }
  };

  const isPromotion = () => {
    return offer.promotion !== null && offer.promotion?.originalRewardIac !== offer.rewardIac;
  };

  return (
    <div
      className={`${c.card} ${index === 0 && isMostPopular ? c["most-popular-border"] : ""}`}
      onClick={() => onModalOpen(offer)}
    >
      {index === 0 && isMostPopular && (
        <span className={c["most-popular-label"]}>Most popular</span>
      )}
      {isPromotion() &&
        ((isMostPopular && detectOs) || (isMostPopular && !detectOs && index === 0)) && (
          <div className={`${c["boost-label"]} ${index !== 0 && c["not-popular"]}`}>
            <ImFire size={17} />
            <span className={c["boost-label-text"]}>
              {getOfferSaleMultiplierLabel(offer.promotion?.multiplier!)}
            </span>
          </div>
        )}
      {showHeroImage() && (
        <div className={c["hero-image-content"]}>
          <img src={offer.heroImageUrl} alt="Logo" />
        </div>
      )}
      <div className={c["card-content"]}>
        <img src={offer.thumbnailUrl} alt="Logo" className={c.logo} />
        <div className={c["text-content"]}>
          {isPromotion() && (!isMostPopular || (isMostPopular && !detectOs && index !== 0)) && (
            <div className={`${c["boost-label"]} ${c["regular"]}`}>
              <ImFire size={10} />
              <span className={c["boost-label-text"]}>
                {getOfferSaleMultiplierLabel(offer.promotion?.multiplier!)}
              </span>
            </div>
          )}
          <p className={c["title"]}>{offer.title}</p>
          {offer.operatingSystems !== null && offer.operatingSystems.length !== 0 && (
            <div className={c.icons}>
              {offer.operatingSystems.map((platform) => (
                <span key={platform}>{platformIcons[platform as Platform] || null}</span>
              ))}
            </div>
          )}
        </div>
        <div className={`${c.points} ${isPromotion() && c["points-boost"]}`}>
          <span className={c["points-text"]}>{isMultiGoal && "Earn up to"}</span>
          {isPromotion() && <span className={c["points-amount-original"]}>{originalCurrency}</span>}
          <span className={c["points-amount"]}>{currency}</span>
        </div>
      </div>
    </div>
  );
}

export default HeroOfferCardItem;
